/* sb-dc-unhide.js - catalogue repairs: cards that were switched off, and one
   that was never there. 2026-09-16.

   Both jobs patch window.__CAT at runtime, the same way
   sb-dc-popupbackdrop.js and sb-dc-yardflag.js do, because the catalogue
   lives in assets/sb-dc-aug.js - 341 KB, past what the theme API will take
   back. Nothing else is touched: sizes, prices, variants and cart behaviour
   all stay where they were.


   1. SHOW - three cards carried `hidden: true`

        Retractable · X-Banner   Double Sided X-Banner (Banner Only)
        Retractable · X-Banner   Double Sided X-Banner (Banner + Stand)
        Stickers                 Custom Shape Kiss-Cut Stickers

      A hidden card is not drawn in the CHOOSE PRODUCT popup, and
      sb-dc-nostart.js can only click a card it can see. When it cannot find
      one it starts on whatever the category had selected - the FIRST card in
      that category. So:

        /products/double-sided-x-banner  opened  Pop up Retractable (Banner Only)
        /products/kiss-cut-stickers      opened  Bumper Stickers

      Both reported 2026-09-16, both confirmed live. The customer designs on
      the wrong board at the wrong price and the cart line is the wrong
      product. To switch a card back off, delete its handle from SHOW.

      2026-09-17: only the two Double Sided cards are in SHOW. Kiss-Cut is
      OUT, on the owner's word - that card was switched off deliberately, and
      snippets/sb-dc-cta.liquid had said so all along ("Bumper, oval and round
      stickers - not kiss-cut", where it decides who gets the Design Templates
      box).

      ⚠ Hiding the card is only half of it. sb-dc-nostart.js can only click a
      card it can see, so /products/kiss-cut-stickers would go straight back
      to opening Bumper Stickers - the reported bug. The other half is that
      the product page must stop offering the design center at all, which is
      what DC_OFF in snippets/sb-dc-cta.liquid now does. Change one and you
      have to change the other.


   2. ADD - Window See-Thru Decals had no card at all

      /products/see-thru-decal opened Custom Vinyl Banners at 8ft x 4ft
      (reported 2026-09-16). The first half of that is a handle-reading bug,
      fixed in sb-dc-handle.js. The other half is this: there was nothing in
      the catalogue to send it to. Pointing it at the neighbouring "Adhesive
      Banners / Window Decals" card is not the same product - that one bills
      at $2.75/sqft against See-Thru's $2.99, and the cart line would carry
      the wrong product entirely.

      Every field below is read off the store's own data, not chosen here:

        rate 2.99      all 285 variants price at exactly $2.99/sqft
                       (2x2 $11.96 ... 50x4 $598.00, no exceptions)
        minSide 2      option values run 2..50 on both sides
        maxSide 50
        maxShort 4     the 285 variants are precisely the pairs whose short
                       side is 2, 3 or 4 - there is no 5x5
        no materials   the product has Width and Height options and no third
        noFinishing    and no finishing option either. Without this flag the
                       card falls through to the bundle's default list of six
                       (hem, grommets, pole pockets) - none of which this
                       product sells, and "Hem + Grommets" also took 2" off
                       every edge of the printable area. A perforated window
                       decal ships cut to size.

      If any of that changes in Shopify, change it here too. To drop the card
      again, empty the ADD list - sb-dc-handle.js then needs its see-thru
      branch pointed back at "window-decals" or the product falls through to
      Custom Vinyl Banners again.

   Diagnostics: window.__dcUnhide() - what was shown, and what was added. */
(function () {
  "use strict";

  var SHOW = {
    "double-sided-x-banner": true
  };

  /* Each entry: the card, and the handle it should sit next to. If that
     neighbour is gone the card is appended to its category instead, and if
     the category is gone too the card is skipped rather than guessed at. */
  var ADD = [{
    after: "window-decals",
    item: {
      handle: "see-thru-decal",
      name: "Window See-Thru Decals",
      nameKo: "Window See-Thru Decal",
      material: "Perforated adhesive vinyl (50% perforation) · 2–50 ft",
      materialEn: "Perforated Adhesive Vinyl",
      unit: "ft",
      rate: 2.99,
      min: 2,
      w: 4,
      h: 4,
      noFinishing: true,
      presets: ["2x2", "2x4", "4x4", "4x8"],
      ftSize: { minSide: 2, maxSide: 50, maxShort: 4 },
      optNames: { w: "Width (Feet)", h: "Height (Feet)" }
    }
  }];

  /* Which finishings a product allows is decided separately from the card, by
     a handle-keyed table inside sb-dc-aug.js, and ANY handle it does not know
     falls back to the full six - hem, grommets, pole pockets. A card added
     here is by definition not in that table, so See-Thru arrived offering all
     six: the right rail showed "Hem + Grommets", and choosing it took 2" off
     every edge of the printable area and would have put a finishing it does
     not sell on the cart line.

     `noFinishing` on the card fixes the starting state but not the list, so
     the five readers are wrapped below. An empty list means the product has
     no finishing at all, which is what a cut-to-size decal is. Anything not
     named here is passed straight through untouched. */
  var FIN = { "see-thru-decal": [] };

  function appliedHandle() {
    var p = window.__dcProduct;
    return (p && p.id) || "";
  }
  function forced() {
    var h = appliedHandle();
    return Object.prototype.hasOwnProperty.call(FIN, h) ? FIN[h] : null;
  }

  function wrapFinishing() {
    if (typeof window.__dcFinishingAllowed !== "function") return false;

    var prevAllowed = window.__dcFinishingAllowed;
    window.__dcFinishingAllowed = function () {
      return forced() || prevAllowed.apply(this, arguments);
    };

    var prevHas = window.__dcHasFinishing;
    if (typeof prevHas === "function") {
      window.__dcHasFinishing = function () {
        var f = forced();
        return f ? f.length > 0 : prevHas.apply(this, arguments);
      };
    }

    var prevList = window.__dcFinishingList;
    if (typeof prevList === "function") {
      window.__dcFinishingList = function (all) {
        var f = forced();
        if (!f) return prevList.apply(this, arguments);
        return (all || []).filter(function (o) { return f.indexOf(o.id) >= 0; });
      };
    }

    var prevPanels = window.__dcPanels;
    if (typeof prevPanels === "function") {
      window.__dcPanels = function (panels) {
        var f = forced();
        if (f && !f.length) {
          return (panels || []).filter(function (p) { return p.id !== "finishing"; });
        }
        return prevPanels.apply(this, arguments);
      };
    }

    var prevKo = window.__dcFinishingFilterKo;
    if (typeof prevKo === "function") {
      window.__dcFinishingFilterKo = function (list) {
        var f = forced();
        if (!f) return prevKo.apply(this, arguments);
        return (list || []).filter(function (o) { return f.indexOf(o.id) >= 0; });
      };
    }

    info.finWrapped = true;
    return true;
  }

  var info = { shown: [], added: [], skipped: [], passes: 0, done: false,
               finWrapped: false };
  window.__dcUnhide = function () { return info; };

  function has(cat, handle) {
    for (var i = 0; i < cat.length; i++) {
      var items = (cat[i] && cat[i].items) || [];
      for (var j = 0; j < items.length; j++) {
        if (items[j] && items[j].handle === handle) return { c: i, i: j };
      }
    }
    return null;
  }

  function sweep() {
    var cat = window.__CAT;
    if (!cat || !cat.length) return false;
    info.passes++;

    var i, j;
    for (i = 0; i < cat.length; i++) {
      var items = (cat[i] && cat[i].items) || [];
      for (j = 0; j < items.length; j++) {
        var it = items[j];
        if (!it || !SHOW[it.handle] || !it.hidden) continue;
        delete it.hidden;
        info.shown.push((cat[i].cat || "?") + " > " + (it.name || it.handle));
      }
    }

    for (i = 0; i < ADD.length; i++) {
      var add = ADD[i];
      if (has(cat, add.item.handle)) continue;        // already there
      var at = has(cat, add.after);
      if (!at) { info.skipped.push(add.item.handle + ": no " + add.after); continue; }
      cat[at.c].items.splice(at.i + 1, 0, add.item);
      info.added.push((cat[at.c].cat || "?") + " > " + add.item.name);
    }

    info.done = true;
    return true;
  }

  /* The bundle builds __CAT and defines the finishing readers while it boots,
     and the popup is drawn after that, so one pass usually lands. The poll
     covers the boot where this file gets there first; it stops as soon as
     both jobs are done. sweep() is safe to repeat - it skips a card that is
     already shown or already added - and wrapFinishing() is guarded so the
     readers are never wrapped twice. */
  var wrapped = wrapFinishing();
  if (!sweep() || !wrapped) {
    var tries = 0;
    var t = setInterval(function () {
      if (!wrapped) wrapped = wrapFinishing();
      if ((sweep() && wrapped) || ++tries > 200) clearInterval(t);
    }, 50);
    addEventListener("pagehide", function () { clearInterval(t); });
  }
})();
